__turbopack_context__.v({
  "categoryItemStyles": "contentCategory-module-scss-module__u9S4PW__categoryItemStyles",
  "isMultiple": "contentCategory-module-scss-module__u9S4PW__isMultiple",
  "leftMargin": "contentCategory-module-scss-module__u9S4PW__leftMargin",
  "listGridStyles": "contentCategory-module-scss-module__u9S4PW__listGridStyles",
  "rightMargin": "contentCategory-module-scss-module__u9S4PW__rightMargin",
  "threeInRowGridStyles": "contentCategory-module-scss-module__u9S4PW__threeInRowGridStyles",
  "twoInRowGridStyles": "contentCategory-module-scss-module__u9S4PW__twoInRowGridStyles",
  "twoItemMaxStyles": "contentCategory-module-scss-module__u9S4PW__twoItemMaxStyles",
});
